import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Select = lazy(() => import(`globalcomponents/UI/Select/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);

const RenderComponent = ({
  values,
  handleEdit,
  validateForm,
  customProps,
  submitAction,
  cancelAction,
}) => {
  const { t } = useTranslation();

  const handleSubmit = async () => {
    const validateResponse = await validateForm();
    submitAction(validateResponse);
  };

  return (
    <>
      <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="companyId">
          {t('policyHolder')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="companyId"
            as={Select}
            placeholder={t('common.pleaseSelect')}
            value={values.companyId}
            suggestions={customProps.fleetCompanyList}
            onChange={(event) => handleEdit(event, { field: 'companyId' })}
          />
          <Message type="error" message={customProps.validationError} />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>

      <FormStyle.default.ButtonsWrapper className="vertical-button">
        <Button
          type="submit"
          label={t('common.view')}
          onClick={handleSubmit}
        />
        <Button
          type="reset"
          label={t('common.clear')}
          onClick={cancelAction}
        />
      </FormStyle.default.ButtonsWrapper>
    </>
  );
};

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  validateForm: PropTypes.func.isRequired,
  customProps: PropTypes.shape({
    fleetCompanyList: PropTypes.array,
    validationError: PropTypes.string,
  }).isRequired,
  submitAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
};

export default RenderComponent;
